module.exports = __webpack_public_path__ + "img/W7023-tran.c1ac5c7e.jpg";